// extracted by mini-css-extract-plugin
module.exports = {"close":"_2KSfC5V","back":"_16UtXtc","light":"_1YKacEP","float":"_1YHkQ-j","arrow":"_3WsyEaR","pointer":"_1o-Uwoz","body":"_LJl9U52","footer":"_3xhLNB3"};